import React, { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useDeviceCompatibility from "../../hooks/useDeviceCompatibility";
import { popToPrevSafeRoute } from "../../hooks/useLastSafeRoute";
import ErrorPopup from "../ErrorPopup";
import DeviceCompatibilityNotice from "../common/DeviceCompatibilityNotice";
import Spinner from "../Spinner";

export function CompatibleRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { status, isCompatible } = useDeviceCompatibility();

  const handleClose = useCallback(() => {
    const currentPath = `${location.pathname || ""}${location.search || ""}${location.hash || ""}`;
    navigate(popToPrevSafeRoute("/home", currentPath), { replace: true });
  }, [location.hash, location.pathname, location.search, navigate]);

  if (status === "checking") {
    return (
      <div
        data-testid="compatible-route-spinner"
        className="flex min-h-[100dvh] items-center justify-center p-4"
      >
        <Spinner />
      </div>
    );
  }

  if (isCompatible) return children;

  return (
    <ErrorPopup
      popup={{
        message: (
          <DeviceCompatibilityNotice titleClassName="text-xl font-semibold" />
        ),
      }}
      onClose={handleClose}
    />
  );
}
